import React from 'react'

const InfoMessage = ({ message }) => {
  if (!message) return null

  return (<span className='info'>{message}</span>)
}

export default InfoMessage
